export const calculateScoreChange = (
  score: number | null | undefined,
  previousScore: number | null | undefined
): number | null => (typeof score === `number` && typeof previousScore === `number` ? score - previousScore : null)
